export default [{
    path: '/bwgShare',
    name: 'bwgShare',
    component: () => import('@/views/guide_page/index'),
  }]